// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"UnknownError_errorPage__2q2WO","tryAgain":"UnknownError_tryAgain__xnxlg"};